require('./policyArchiving.style.scss');
const Archive = require('../../../../model/Archive');
const Filter = require('../../../../../shared/ctxFiltersPanel/ctxFilterModel');
const { permissions } = require('../../../../constants/permissions');
const HELP_SPECIFY = 'archiving',
    HELP_CREATE = 'archiving';

class PgArchivingController {
    constructor(
        $scope,
        $filter,
        $element,
        $timeout,
        policiesPersistence,
        dialogService,
        notificationService,
        contentSwitcherService,
        policiesUtils,
        utilsService,
        validationsService,
        iamPersistenceService
    ) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$element = $element;
        this.$timeout = $timeout;
        this.persistence = policiesPersistence;
        this.dialogService = dialogService;
        this.notificationService = notificationService;
        this.contentSwitcherService = contentSwitcherService;
        this.policiesUtils = policiesUtils;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.iamPersistenceService = iamPersistenceService;
        this.mainTitle = this.$filter('translate')('policy.toolbar.archiving.label');
        this.modalTitle = this.mainTitle;
        this.modalSubTitle = null;
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';
        this.configArchivingTable();
        this.selectedArchiving = [];
        this.CREATE_STATE = 'create';
        this.EDIT_STATE = 'edit';
        this.MAIN_STATE = 'main';
        this.numberPattern = this.validationsService.getNumberPattern();

        this.day = {};
        this.week = {};
        this.month = {};
        this.year = {};

        this.days = [
            { label: this.$filter('translate')('policy.archiving.days.monday'), value: 'MONDAY' },
            { label: this.$filter('translate')('policy.archiving.days.tuesday'), value: 'TUESDAY' },
            { label: this.$filter('translate')('policy.archiving.days.wednesday'), value: 'WEDNESDAY' },
            { label: this.$filter('translate')('policy.archiving.days.thursday'), value: 'THURSDAY' },
            { label: this.$filter('translate')('policy.archiving.days.friday'), value: 'FRIDAY' },
            { label: this.$filter('translate')('policy.archiving.days.saturday'), value: 'SATURDAY' },
            { label: this.$filter('translate')('policy.archiving.days.sunday'), value: 'SUNDAY' },
        ];
        this.months = [
            { label: this.$filter('translate')('policy.archiving.months.january'), value: 'JANUARY' },
            { label: this.$filter('translate')('policy.archiving.months.february'), value: 'FEBRUARY' },
            { label: this.$filter('translate')('policy.archiving.months.march'), value: 'MARCH' },
            { label: this.$filter('translate')('policy.archiving.months.april'), value: 'APRIL' },
            { label: this.$filter('translate')('policy.archiving.months.may'), value: 'MAY' },
            { label: this.$filter('translate')('policy.archiving.months.june'), value: 'JUNE' },
            { label: this.$filter('translate')('policy.archiving.months.july'), value: 'JULY' },
            { label: this.$filter('translate')('policy.archiving.months.august'), value: 'AUGUST' },
            { label: this.$filter('translate')('policy.archiving.months.september'), value: 'SEPTEMBER' },
            { label: this.$filter('translate')('policy.archiving.months.october'), value: 'OCTOBER' },
            { label: this.$filter('translate')('policy.archiving.months.november'), value: 'NOVEMBER' },
            { label: this.$filter('translate')('policy.archiving.months.december'), value: 'DECEMBER' },
        ];
    }

    $onInit() {
        if (this.animateSwitcher && !this.minInnerHeight) {
            this.minInnerHeight = this.getMinHeight();
        }
        this.initialize();
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => {
                    this.onBackAction();
                },
                isVisible: () => this.state !== this.MAIN_STATE,
                btnClass: 'ctx-btn-secondary',
                id: 'policies-archiving-back',
            },
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: () => {
                    this.saveArchiving();
                },
                isVisible: () => this.state !== this.MAIN_STATE,
                isDisabled: () => {
                    return (
                        !this.enabledOptions ||
                        !this.enabledOptions.length ||
                        (this.dialogForm && !this.dialogForm.$valid) ||
                        this.busy
                    );
                },
                id: 'policies-archiving-save',
            },
        ];
        this.dayWatcher = this.$scope.$watch(
            () => this.day.target,
            (value) => {
                if (!this.day.accessTier) {
                    this.day.accessTier = this.defaultValue;
                }
            }
        );

        this.weekWatcher = this.$scope.$watch(
            () => this.week.target,
            (value) => {
                if (!this.week.accessTier) {
                    this.week.accessTier = this.defaultValue;
                }
            }
        );
        this.monthWatcher = this.$scope.$watch(
            () => this.month.target,
            (value) => {
                if (!this.month.accessTier) {
                    this.month.accessTier = this.defaultValue;
                }
            }
        );
        this.yearWatcher = this.$scope.$watch(
            () => this.year.target,
            (value) => {
                if (!this.year.accessTier) {
                    this.year.accessTier = this.defaultValue;
                }
            }
        );

        // ENABLED OPTIONS
        this.$scope.$watchCollection(
            () => this.enabledOptions,
            (options, previousOptions) => {
                if (!options) return;
                this.showDay = options.indexOf('day') >= 0;
                this.showWeek = options.indexOf('week') >= 0;
                this.showMonth = options.indexOf('month') >= 0;
                this.showYear = options.indexOf('year') >= 0;
                /** scrollToElement is comment because:
                 *  On smaller resolution whenever you click on tag you will be scroll to specific element, and
                 *  then you must scroll back to ctxClickableTags component to be able to select new option */
                // if(previousOptions && previousOptions.length && previousOptions.length < options.length) {
                //     let items = options.filter(i => previousOptions.indexOf(i) < 0);
                //     this.scrollToElement(items[0])
                // }
            }
        );
        // this.load();
    }

    initialize() {
        this.tzSearch = {};
        this.targetSearch = {};
        this.targets = this.allTargets = [];
        this.oldArchiveName = '';
        if (this.utilsService.isBackUpAdmin()) {
            this.persistence.getTargets().then((res) => {
                // res.forEach(target => this.targets.push({ label: target.name, value: target.uuid }));
                this.targets.day = this.targets.month = this.targets.week = this.targets.year = this.allTargets = res;
            });
        }
        this.setDefaultValues();
        this.startAtHours = 0;
        this.startAtMin = 0;
        this.selectedDay = this.days[0];
        this.accessTiers = [
            { id: 1, value: 'Hot', label: 'Hot' },
            { id: 2, value: 'Cool', label: 'Cool' },
            { id: 3, value: 'Archive', label: 'Archive' },
        ];

        this.defaultValue = {
            id: null,
            label: this.$filter('translate')('policy.edit.form.target.auto'),
            value: null,
            isOriginal: true,
            isDefault: true,
            isSelected: false,
        };
    }

    setDefaultValues() {
        this.day = { retention: 7, target: this.defaultValue, accessTier: this.defaultValue };
        this.week = { retention: 8, target: this.defaultValue, accessTier: this.defaultValue };
        this.month = { retention: 6, dayOfMonth: 1, target: this.defaultValue, accessTier: this.defaultValue };
        this.year = {
            retention: 7,
            monthOfYear: this.months[0],
            dayOfMonth: 1,
            target: this.defaultValue,
            accessTier: this.defaultValue,
        };
    }

    initializeAvailiableTimezones() {
        const tmz = moment.tz.guess();
        this.availiableTimezones = this.allTimezones = this.utilsService.getAllTimezones();
        this.selectedTimezone = this.availiableTimezones.find((t) => t.name === tmz);
    }

    getLocalUTCOffset() {
        var localDate = new Date();
        var sign = localDate.getTimezoneOffset() > 0 ? '-' : '+';
        var offset = this.convertToHourMinutes(Math.abs(localDate.getTimezoneOffset()));
        return 'UTC' + sign + offset;
    }

    convertToHourMinutes(minutes) {
        let h = Math.floor(minutes / 60),
            m = minutes % 60;
        return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    }

    onOpen() {
        this.helpId = HELP_SPECIFY;
        this.state = this.MAIN_STATE;
        this.closeId = { close: 'policies-archiving-close', closeIcon: 'policies-archiving-close-icon' };
        this.load(true);
    }

    onBackAction() {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.onCloseModal();
            });
        } else {
            this.onCloseModal();
        }
    }

    onCloseModal() {
        if (this.state !== this.MAIN_STATE) {
            this.state = this.MAIN_STATE;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.helpId = HELP_SPECIFY;
            return { preventDefault: true };
        }
        this.persistence.archiveTableState.searchBy = '';
        this.selectedArchiving = [];
        this.state = this.MAIN_STATE;
        this.onClose({ success: true });
        this.dayWatcher();
        this.weekWatcher();
        this.monthWatcher();
        this.yearWatcher();
        this.showModal = false;
        this.archive = null;
        this.week = null;
        this.year = null;
        this.month = null;
        this.startAtHours = null;
        this.startAtMin = null;
    }

    onTitleClick() {
        this.changeState(this.MAIN_STATE);
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === this.MAIN_STATE) {
            this.helpId = HELP_SPECIFY;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
        } else {
            this.helpId = HELP_CREATE;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle =
                ' » ' +
                (state === this.CREATE_STATE
                    ? this.$filter('translate')('policy.archiving.new.title')
                    : this.$filter('translate')('policy.archiving.edit.title') + ' ' + this.archive.name);
        }
        this.state = state;
    }

    newArchive() {
        this.archive = this.persistence.newArchive();
        this.prepareFilterTags(true);
        this.changeState(this.CREATE_STATE);
        this.initialize();
    }

    editArchiving() {
        if (!this.selectedArchiving[0]) return;
        this.setDefaultValues();
        return this.persistence.getArchive(this.selectedArchiving[0].uuid).then(
            (archive) => {
                this.archive = archive;
                this.oldArchiveName = archive.name;
                this.archive.archiveSpecifics.forEach((arc) => {
                    // this.selectedTimezone = this.availiableTimezones.filter(item => item.value === arc.timezone)[0] || this.availiableTimezones[0];
                    this.selectedTimezone =
                        this.availiableTimezones.filter((otz) => otz.name === arc.timezone.name)[0] ||
                        this.availiableTimezones[0];
                    this.startAtHours = arc.hourOfDay || 0;

                    if (arc.minuteOfHour !== undefined && arc.minuteOfHour > 0 && arc.minuteOfHour < 10) {
                        this.startAtMin = '0' + arc.minuteOfHour;
                    } else {
                        this.startAtMin = arc.minuteOfHour || 0;
                    }
                    let day = this.reverseConvertArchiveType(arc.archiveType.toLowerCase());
                    this.setData(day, arc);
                    if (day === 'week') {
                        this.selectedDay = this.days.filter((item) => item.value === arc.dayOfWeek)[0];
                    }
                    if (day === 'year') {
                        this.year.monthOfYear = this.months.filter((item) => item.value === arc.monthOfYear)[0];
                    }
                });
                this.prepareFilterTags();
                this.changeState(this.EDIT_STATE);
            },
            (err) => {}
        );
    }

    saveArchiving() {
        let tempList = [];
        this.busy = true;
        this.enabledOptions.forEach((option) => {
            tempList.push(this.switchOptions(option));
        });
        this.archive.archiveSpecifics = tempList;
        this.persistence[this.state === this.CREATE_STATE ? 'createArchive' : 'updateArchive'](
            this.archive,
            this.oldArchiveName
        ).then(
            (res) => {
                this.reload = this.reload || this.state === this.EDIT_STATE;
                this.switcherOnChange = true;
                this.state === this.CREATE_STATE
                    ? this.reloadOnSave(true, this.archive)
                    : this.load(false, false, this.archive);
                this.notificationService.pop(res.data.message);
                this.changeState(this.MAIN_STATE);
            },
            (err) => {
                this.busy = false;
            }
        );
    }

    deleteArchive() {
        let archive = this.selectedArchiving[0];
        if (!archive) return;
        this.persistence.checkForPolicy('archives', archive).then((res) => {
            if (!res.length > 0) {
                return this.dialogService
                    .showYesNo(
                        this.$filter('translate')('policy.archiving.deleteDialogNoAssigned.text'),
                        this.$filter('translate')('policy.archiving.deleteDialog.title'),
                        null,
                        'delete-archive'
                    )
                    .then((result) => {
                        if (result) {
                            this.reload = true;
                            return this.persistence.deleteArchive(archive);
                        }
                    })
                    .then(
                        (res) => {
                            if (res) {
                                this.afterDeletionAction(res);
                            }
                        },
                        (err) => {}
                    );
            } else {
                return this.dialogService
                    .showYesNo(
                        this.$filter('translate')('policy.archiving.deleteDialog.text', {
                            name: archive.name,
                            policies: res.toString().replace(/,/g, ', '),
                        }),
                        this.$filter('translate')('policy.archiving.deleteDialog.title'),
                        null,
                        'delete-archive'
                    )
                    .then((result) => {
                        if (result) {
                            this.reload = true;
                            return this.persistence.deleteArchive(archive);
                        }
                    })
                    .then(
                        (res) => {
                            if (res) {
                                this.afterDeletionAction(res);
                            }
                        },
                        (err) => {}
                    );
            }
        });
    }

    afterDeletionAction(res) {
        this.notificationService.pop(res.data.message);
        this.selectedArchiving = [];
        this.load(null, true);
    }

    setData(name, arc) {
        let cap = 'show' + name.charAt(0).toUpperCase() + name.slice(1);

        this[cap] = true;
        this[name] = arc;
        this[name].retention = arc.retention;
        this[name].target = this.targets[name].filter((item) => item.value === arc.target)[0];
        if (this[name].target && this[name].target.kind !== 'Storage') {
            this[name].accessTier = this.accessTiers.filter((item) => item.value === arc.accessTier)[0];
        }
        if (!this[name].target) {
            this[name].target = this.defaultValue;
            this[name].accessTier = this.accessTiers.filter((item) => item.value === arc.accessTier)[0];
        }
        if (this[name].target.kind !== 'Storage' && !this[name].accessTier) {
            this[name].accessTier = this.defaultValue;
        }
    }

    switchOptions(name) {
        if (name !== 'day' && name !== 'week' && name !== 'month' && name !== 'year') return {};
        let date = new Date();
        let weekData = this.getWeekData();
        return {
            retention: this[name].retention,
            target: this[name].target ? this[name].target.value : null,
            timezone: this.selectedTimezone
                ? { name: this.selectedTimezone.name, offset: this.selectedTimezone.tmz }
                : null,
            accessTier:
                this[name].accessTier && this[name].target.kind !== 'Storage' ? this[name].accessTier.value : null,
            dayOfWeek: name === 'week' ? this.selectedDay.value : null,
            archiveType: this.convertArchiveType(name),
            dayOfMonth: name === 'day' ? date.getDate() : name === 'week' ? weekData.day : this[name].dayOfMonth,
            monthOfYear:
                name === 'year'
                    ? this.year.monthOfYear.value
                    : name === 'week'
                    ? weekData.month
                    : this.months[date.getMonth()].value,
            hourOfDay: this.startAtHours,
            minuteOfHour: this.startAtMin,
        };
    }

    getWeekData() {
        let result = { day: '', month: '', year: '' };
        let currentDayIndex = new Date().getDay() - 1;
        let selectedDayIndex = this.days.map((d) => d.value).indexOf(this.selectedDay.value);
        let daysDiff = selectedDayIndex - currentDayIndex;
        let selectedDate = new Date();
        selectedDate.setDate(selectedDate.getDate() + daysDiff);
        result.day = selectedDate.getDate();
        result.month = this.months[selectedDate.getMonth()].value;
        result.year = selectedDate.getFullYear();
        return result;
    }

    convertArchiveType(type) {
        switch (type) {
            case 'day':
                return 'ARCHIVE_DAILY';
            case 'week':
                return 'ARCHIVE_WEEKLY';
            case 'month':
                return 'ARCHIVE_MONTHLY';
            case 'year':
                return 'ARCHIVE_YEARLY';
        }
    }

    reverseConvertArchiveType(type) {
        switch (type) {
            case 'archive_daily':
                return 'day';
            case 'archive_weekly':
                return 'week';
            case 'archive_monthly':
                return 'month';
            case 'archive_yearly':
                return 'year';
        }
    }

    prepareFilterTags(isNew) {
        let weeklySet = isNew,
            monthlySet = false,
            yearlySet = false,
            dailySet = false;
        if (!isNew) {
            this.archive.archiveSpecifics.forEach((item) => {
                if (item.archiveType === 'ARCHIVE_DAILY') dailySet = true;
                else if (item.archiveType === 'ARCHIVE_WEEKLY') weeklySet = true;
                else if (item.archiveType === 'ARCHIVE_MONTHLY') monthlySet = true;
                else if (item.archiveType === 'ARCHIVE_YEARLY') yearlySet = true;
            });
        }
        this.availableOptions = [
            {
                id: 'every-day-tag',
                label: this.$filter('translate')('policy.archiving.defaultValues.day'),
                color: 'archiving-every-day',
                value: 'day',
                selected: dailySet,
            },
            {
                id: 'every-week-tag',
                label: this.$filter('translate')('policy.archiving.defaultValues.week'),
                color: 'archiving-every-week',
                value: 'week',
                selected: weeklySet,
            },
            {
                id: 'every-month-tag',
                label: this.$filter('translate')('policy.archiving.defaultValues.month'),
                color: 'archiving-every-month',
                value: 'month',
                selected: monthlySet,
            },
            {
                id: 'every-year-tag',
                label: this.$filter('translate')('policy.archiving.defaultValues.year'),
                color: 'archiving-every-year',
                value: 'year',
                selected: yearlySet,
            },
        ];
    }

    load(firstPage, animate, archive) {
        this.initializeAvailiableTimezones();
        return this.persistence.getArchives(firstPage).then((archivig) => {
            let selectedItem;
            this.archivingItems = archivig;
            if (this.animateSwitcher && animate && !this.switcherOnChange) {
                this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                    this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                    this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                });
            }
            if (archive) {
                selectedItem = this.archivingItems.filter((item) => item.name === archive.name)[0];
                if (selectedItem) this.selectedArchiving = [selectedItem];
            } else {
                this.selectedArchiving = [this.archivingItems[0]];
            }
            this.switcherOnChange = false;
            this.busy = false;
            return {
                page: this.persistence.archiveTableState ? this.persistence.archiveTableState.page : 1,
                selected: selectedItem,
                length: this.archivingItems.length,
            };
        });
    }

    reloadOnSave(firstPage, item) {
        if (!firstPage) this.persistence.archiveTableState.page++;
        else this.persistence.archiveTableState.searchBy = undefined;

        this.switcherOnChange = true;
        this.load(firstPage, false, item).then((res) => {
            if (!res.length) return;
            if (!res.selected) {
                this.reloadOnSave(false, this.archive);
            }
        });
    }

    configArchivingTable() {
        this.archivingTableConfig = [
            this.$filter('translate')('policy.archiving.name'),
            this.$filter('translate')('policy.archiving.description'),
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: [],
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');

        this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
        this.gridFlag = true;
    }

    sortTable() {
        this.load();
    }

    getMinHeight() {
        let modalBody = this.$element.find('.modal-body'),
            minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight
            ? parseFloat(minHeight) -
                  parseFloat(modalBody.css('padding-top')) -
                  parseFloat(modalBody.css('padding-bottom'))
            : null;
    }

    disableActions() {
        return this.selectedArchiving[0] === undefined;
    }

    scrollToElement(id) {
        this.$timeout(() => {
            let position = id ? this.$element.find('#' + id)[0] : 'bottom';
            this.$element.closest('.modal-body').mCustomScrollbar('scrollTo', position, { timeout: 0 });
        }, 150);
    }

    searchTimezone() {
        this.availiableTimezones = this.allTimezones.filter(
            (tz) => tz.label.toLowerCase().indexOf(this.tzSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchTargets(period) {
        this.targets[period] = this.allTargets.filter(
            (target) => target.label.toLowerCase().indexOf(this.targetSearch[period].searchBy.toLowerCase()) !== -1
        );
    }

    isCreateArchiveDisabled() {
        return !this.hasCreateArchivePermissions();
    }

    isUpdateArchiveDisabled() {
        return this.selectedArchiving[0] === undefined || !this.hasEditArchivePermissions();
    }

    isDeleteArchiveDisabled() {
        return this.selectedArchiving[0] === undefined || !this.hasDeleteArchivePermissions();
    }

    hasArchiveListPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.ARCHIVES_LISTING);
    }

    hasCreateArchivePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.ARCHIVE_CREATE);
    }

    hasEditArchivePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.ARCHIVE_UPDATE);
    }

    hasDeleteArchivePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.ARCHIVE_DELETE);
    }
}

PgArchivingController.$inject = [
    '$scope',
    '$filter',
    '$element',
    '$timeout',
    'policiesPersistence',
    'dialogService',
    'notificationService',
    'contentSwitcherService',
    'policiesUtils',
    'utilsService',
    'validationsService',
    'iamPersistenceService',
];

const pgArchivingComponent = {
    controller: PgArchivingController,
    template: require('./policyArchiving.template.html'),
    bindings: {
        showModal: '=',
        onClose: '&',
    },
};

module.exports = pgArchivingComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/policies/dialogs/policyArchiving/policyArchiving.component.js